(function() {
    angular
        .module("app")
        .controller("IFrameController", IFrameController)

    IFrameController.$inject = [
        "$rootScope",
        "$scope",
        "$sce",
        "$cookies",
        "$uibModalInstance",
        "frameData",
        "tutorialType"
    ]

    function IFrameController(
        $rootScope,
        $scope,
        $sce,
        $cookies,
        $uibModalInstance,
        frameData,
        tutorialType
    ){
        "use strict"

        $scope.tutorialType = tutorialType

        $scope.iFrame = {
            url: $sce.trustAsResourceUrl(frameData.url),
            height: frameData.height
        }

        $scope.setTutorialCookie = function(showTutorials) {
            $cookies.putObject("tutorials." + frameData.cookie, showTutorials)
            $rootScope.tutorials[frameData.cookie] = showTutorials
            $uibModalInstance.close()
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
